import Swiper from 'swiper/bundle';

export default () => {
  const breakpoint = window.matchMedia( '(max-width:850px)' );
  let slider;

  const breakpointChecker = function() {
    if ( breakpoint.matches === false ) {
      if ( slider !== undefined ) slider.destroy( true, true );
      return;
    } else if ( breakpoint.matches === true) {
      return enableSwiper();
    }
  };

  const enableSwiper = function() {
    const sliderPrefix = 'special__';
    const sliderEl = document.querySelector(`.${sliderPrefix}slider-wrapper`);
    const slideTransitionSpeed = 700;

    if (sliderEl) {
      let paginationEl = document.querySelector('.home-products__pagination .pagination');

      slider = new Swiper(sliderEl, {
        wrapperClass: `${sliderPrefix}grid`,
        slideClass: `${sliderPrefix}item`,
        slideActiveClass: `${sliderPrefix}item--active`,
        slidesPerView: 'auto',
        speed: slideTransitionSpeed,
        loop: true,
        spaceBetween: 10,
        watchOverflow: true,
        breakpoints: {
          // 767: {
            
          // },
          
        },
        // pagination: {
        //   el: paginationEl,
        //   type: 'bullets',
        //   clickable: true,
        //   bulletClass: 'pagination__bullet',
        //   bulletActiveClass: 'pagination__bullet--active'
        // },
      });
    }
  };

  breakpoint.addListener(breakpointChecker);
  breakpointChecker();
}